import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? "md:flex-col md:items-center md:text-center" : ""
      }`}
    >
      <div className={`max-w-2xl ${isCenter ? "md:mx-auto" : ""}`}>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
            <span className="inline-block h-3 w-1 rounded-full bg-primary-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}